import { PageLayout, PageListHeader } from '@/global/components';
import { FC } from 'react';
import { UnifiedProfilePageProps, UnifiedProfileSearchbar } from '../common';

export const UnifiedProfileSearch: FC<UnifiedProfilePageProps> = ({ breadcrumbs }) => {
  return (
    // In this page, borders have been intentionally disabled for UI requirements. The image is meant to extend fully to the edge of the page.
    <PageLayout className='px-0 pb-0'>
      <PageListHeader
        classNames={{ wrapper: 'px-8' }}
        breadcrumbs={breadcrumbs}
        title='unifiedProfile:unifiedProfilesTitle'
        subtitle='unifiedProfile:unifiedProfilesSearchSubtitle'
      />
      <div className='flex grow'>
        <UnifiedProfileSearchbar />
        <div className='flex grow lg:bg-[url("/assets/image/create-campaign-step-bg.svg")] lg:bg-contain lg:bg-[position:100%_100%] lg:bg-no-repeat' />
      </div>
    </PageLayout>
  );
};
